import React, { useEffect, useState, type ReactNode } from 'react';
import type { SearchInputRenderParams } from './type';
import { BaseSearchTrigger } from './base-trigger';

type InputSearchProps = SearchInputRenderParams & {
  after?: ReactNode;
};

export const InputSearch: React.FC<InputSearchProps> = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  after,
  suffixContent
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  const prevValueRef = React.useRef(value);
  const rightContent = after ?? suffixContent;

  useEffect(() => {
    if (!isFocused && prevValueRef.current !== value) {
      setLocalValue(value);
      prevValueRef.current = value;
    } else if (!isFocused) {
      prevValueRef.current = value;
    }
  }, [value, isFocused]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onChange(localValue);
      onBlur();
    }
    onKeyDown?.(event);
  };

  const handleBlur = () => {
    setIsFocused(false);
    onChange(localValue);
    onBlur();
  };

  return (
    <BaseSearchTrigger
      value={localValue}
      hasValue={!!value}
      isFocused={isFocused}
      onChange={event => setLocalValue(event.target.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      rightContent={rightContent}
    />
  );
};
